/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFZoomyDomainConfidenceMapScore } from './CRSFZoomyDomainConfidenceMapScore';
import {
    CRSFZoomyDomainConfidenceMapScoreFromJSON,
    CRSFZoomyDomainConfidenceMapScoreFromJSONTyped,
    CRSFZoomyDomainConfidenceMapScoreToJSON,
} from './CRSFZoomyDomainConfidenceMapScore';

/**
 * Model that holds all domain confidence scores done for the expansion domains against a single account domain.
 * @export
 * @interface CRSFZoomyAccountDomainConfidenceMap
 */
export interface CRSFZoomyAccountDomainConfidenceMap {
    /**
     * 
     * @type {string}
     * @memberof CRSFZoomyAccountDomainConfidenceMap
     */
    account_domain: string;
    /**
     * 
     * @type {{ [key: string]: CRSFZoomyDomainConfidenceMapScore; }}
     * @memberof CRSFZoomyAccountDomainConfidenceMap
     */
    confidence_map: { [key: string]: CRSFZoomyDomainConfidenceMapScore; };
}

/**
 * Check if a given object implements the CRSFZoomyAccountDomainConfidenceMap interface.
 */
export function instanceOfCRSFZoomyAccountDomainConfidenceMap(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "account_domain" in value;
    isInstance = isInstance && "confidence_map" in value;

    return isInstance;
}

export function CRSFZoomyAccountDomainConfidenceMapFromJSON(json: any): CRSFZoomyAccountDomainConfidenceMap {
    return CRSFZoomyAccountDomainConfidenceMapFromJSONTyped(json, false);
}

export function CRSFZoomyAccountDomainConfidenceMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFZoomyAccountDomainConfidenceMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_domain': json['account_domain'],
        'confidence_map': (mapValues(json['confidence_map'], CRSFZoomyDomainConfidenceMapScoreFromJSON)),
    };
}

export function CRSFZoomyAccountDomainConfidenceMapToJSON(value?: CRSFZoomyAccountDomainConfidenceMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_domain': value.account_domain,
        'confidence_map': (mapValues(value.confidence_map, CRSFZoomyDomainConfidenceMapScoreToJSON)),
    };
}

